import $ from "jquery";

$(function() {
  console.log('inspiratiepunten-node.js Ready');

  $('#iprt-page-transition').fadeOut(1000, function() {
    $(this).remove();
  });






  const fx = $('.fx');



  $(window).on('scroll', windowScroll);

  function windowScroll() {
      fx.each(function() {
        const elm = $(this);

        if (inViewPort(elm)) {
          elm.addClass('fx-active');
        }
      });
      
      // if (inViewPort($myDiv)) {
      //     console.log('Element is in viewport');
      // }

      // if (passedViewPortMiddle($myDiv)) {
      //     console.log('Element passed viewport middle');
      // }
  }

  function inViewPort(element) {
      if (!element.length) return false;
      const rect = element[0].getBoundingClientRect();
      return (
          rect.top <= window.innerHeight && 
          rect.bottom >= 0
      );
  }

  function passedViewPortMiddle(element) {
      if (!element.length) return false;
      const rect = element[0].getBoundingClientRect();
      const elementMiddle = rect.top + (rect.height / 2);
      const viewportMiddle = window.innerHeight / 2;
      return elementMiddle <= viewportMiddle;
  }

  setTimeout(() => {
    windowScroll();
  }, 1500);
});